export default __webpack_public_path__ + "static/media/33.30b53d2e.png";